/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      this.isPaused = false;

      this.bindEvents();
      this.init();
      this.formatCurrencyText();
    }

    disconnectedCallback() {
      if (this.moveLinksHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
    }

    bindEvents() {
      if (this.links) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler
          || debounce(this.moveLocalization.bind(this));
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }

      if (this.slider) {
        this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
        this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
      }
    }

    formatCurrencyText(raw) {
        const text = raw.trim();

        // Matches: "New Zealand (NZD $)" -> captures "NZD $"
        const parenMatch = text.match(/\(([^)]+)\)\s*$/);
        if (parenMatch?.[1]) return parenMatch[1].trim();

        // Fallback: if it already contains "NZD $" etc, try to pull "AAA $" shape
        const codeSymbolMatch = text.match(/\b([A-Z]{3})\s*([$€£¥]|฿)\b/);
        if (codeSymbolMatch) return `${codeSymbolMatch[1]} ${codeSymbolMatch[2]}`;

        return text;
    }

    /**
     * Start sliders a slidin'
     */
    init() {
      // if (this.slider) {
      //   const slides = this.slider.querySelectorAll('.announcement__text');
      //   slides[0].classList.add('is-visible');

      //   const nextSlide = () => {
      //     if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
      //       const currSlide = this.slider.querySelector('.announcement__text.is-visible');
      //       const currSlideIndex = Array.from(currSlide.parentNode.children)
      //         .indexOf(currSlide);
      //       const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;

      //       if (document.dir === 'rtl') {
      //         this.slider.scrollTo(
      //           -Math.abs(nextSlideIndex * slides[nextSlideIndex].clientWidth),
      //           0
      //         );
      //       } else {
      //         this.slider.scrollTo(slides[nextSlideIndex].offsetLeft - 32, 0);
      //       }

      //       slides[nextSlideIndex].classList.add('is-visible');
      //       slides[currSlideIndex].classList.remove('is-visible');
      //     }

      //     setTimeout(nextSlide, this.dataset.slideDelay);
      //   };
      //   setTimeout(nextSlide, this.dataset.slideDelay);
      // }

      if (this.slider) {
        const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;

        const rotator = this.querySelector('.flex');
        const track = this.querySelector('.announcement__slider');
        const slideEls = Array.from(this.querySelectorAll('.announcement__text'));

        let stars = '';
        for (let i = 0; i < 5; i++) {
            stars += '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none"><path d="M6.65735 0L8.22895 4.83688H13.3147L9.20025 7.82624L10.7718 12.6631L6.65735 9.67376L2.54285 12.6631L4.11445 7.82624L-4.72069e-05 4.83688H5.08575L6.65735 0Z" fill="#FFBD01"/></svg>';
        }

        slideEls.forEach(el => {
          const strong = el.querySelector('strong');
          if (!strong) return;
          const text = strong.textContent.trim().toLowerCase().replace(/[^a-z0-9,+\s]/gi, '');
          if (text && text.includes('review')) {
              strong.innerHTML = '<span class="sv-review-stars">' + stars + '</span>&nbsp;' + text;
          }
        });


        if (!rotator || !track || slideEls.length <= 1) return;

        let index = 0;
        let intervalId = null;

        const getSlideHeight = () => {
            const h = slideEls[0]?.getBoundingClientRect().height || 0;
            return Math.max(1, Math.round(h));
        };

        const applyTransform = () => {
            const h = getSlideHeight();
            track.style.transform = `translateY(-${index * h}px)`;
        };

        const start = () => {
            if (!isMobile()) return;
            if (intervalId) return;

            // Ensure the container height matches one slide
            rotator.style.height = `${getSlideHeight()}px`;
            applyTransform();

            intervalId = window.setInterval(() => {
                index = (index + 1) % slideEls.length;
                applyTransform();
            }, 3000);
        };

        const stop = () => {
            if (intervalId) {
                window.clearInterval(intervalId);
                intervalId = null;
            }
            // reset when leaving mobile
            index = 0;
            track.style.transform = '';
            rotator.style.height = '';
        };

        const sync = () => {
            if (isMobile()) start();
            else stop();
        };

        sync();
        window.addEventListener('resize', sync);
      }

      if (this.links) {
        // this.moveLinks();
      }

      if (this.localization) {
        this.moveLocalization();
      }
    }

    /**
     * Move the help links selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!theme.mediaMatches.md && !menuAnnouncementLinks) {
        // Move localization to mobile
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links');

        const mobNavUl = document.createElement('ul');
        mobNav.classList.add('secondary-nav');

        this.links.forEach((link) => {
          mobNav.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
        });

        mobNav.appendChild(mobNavUl);
        this.menu.appendChild(mobNav);
      } else if (theme.mediaMatches.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    /**
     * Move the localization selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLocalization() {
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content'); // mobile menu
      this.desktopMenu = document.querySelector('.header .header__icons'); // desktop menu
      const menuLocalization = document.querySelector('.mob__localization');
      const localization = document.querySelector('#nav-localization');
      const desktopMenuLocalization = document.querySelector('.sv-locator');
      if (!theme.mediaMatches.md && !menuLocalization) {
        // Move localization to mobile
        const mobLocalizationElem = document.createElement('div');
        mobLocalizationElem.classList.add('mob__localization');
        mobLocalizationElem.appendChild(localization);
        this.menu.appendChild(mobLocalizationElem);
        if (desktopMenuLocalization) {
          desktopMenuLocalization.remove();
        }
      } else if (theme.mediaMatches.md && !desktopMenuLocalization) {
        // Move localization back to announcement bar
        const deskLocalizationElem = document.createElement('div');
        deskLocalizationElem.classList.add('sv-locator');
        deskLocalizationElem.appendChild(localization);
        this.desktopMenu.prepend(deskLocalizationElem);
        if (menuLocalization) {
          menuLocalization.remove();
        }
      } 
    }

    /**
     * Pauses the auto-rotating slider
     */
    pauseSlider() {
      this.isPaused = true;
    }

    /**
     * Resumes the auto-rotating slider
     */
    resumeSlider() {
      this.isPaused = false;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
